import React, { PureComponent } from "react";
import { ReportsStatus } from "./ReportsStatus";
import { PieChart, Pie, Cell } from "recharts";

export class ReportsDonutChart extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: [
        { name: "Group A", value: 20 },
        { name: "Group B", value: 40 },
        { name: "Group C", value: 30 },
        { name: "Group D", value: 20 },
        { name: "Group D", value: 20 },
        { name: "Group D", value: 20 },
      ],
      COLORS: [
        "#225425",
        "#FFC350",
        "#BAC21B",
        "#F46E19",
        "#EA3925",
        "#419E35",
      ],
      STROKE: [
        "#225425",
        "#FFC350",
        "#BAC21B",
        "#F46E19",
        "#EA3925",
        "#419E35",
      ],
    };
  }
  render() {
    return (
      <React.Fragment>
        <div className="d-flex main-donut-pie-chart">
          <div className="col-3 pr-0">
            <div className="height-content">
              <ReportsStatus
                colorBox="color-box box-color-yellow"
                paratext="Pending"
                value="40"
              />
            </div>
            <div>
              <ReportsStatus
                colorBox="color-box box-color-gray"
                paratext="Not Seated"
                value="40"
              />
            </div>
          </div>
          <div className="col-6 p-0 d-flex align-items-center justify-content-center">
            <div className="dount-chart-circle">
              <PieChart width={200} height={200} onMouseEnter={this.onPieEnter}>
                <Pie
                  data={this.state.data}
                  cx={80}
                  cy={80}
                  innerRadius={62}
                  outerRadius={80}
                  fill="#8884d8"
                  stroke="#8884d8"
                  paddingAngle={0}
                >
                  {this.state.data.map((entry, index) => (
                    <Cell
                      fill={this.state.COLORS[index % this.state.COLORS.length]}
                      stroke={
                        this.state.STROKE[index % this.state.STROKE.length]
                      }
                    />
                  ))}
                </Pie>
              </PieChart>
            </div>
          </div>
          <div className="col-3 pl-0">
            <div className="height-content">
              <ReportsStatus
                colorBox="color-box box-color-darkgreen"
                paratext="Completed"
                value="40"
              />
            </div>
            <div className="col-12 pr-0">
              <ReportsStatus
                colorBox="color-box box-color-lightgreen"
                paratext="Seated"
                value="40"
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ReportsDonutChart;
